module.exports = __webpack_public_path__ + "static/media/fk.cede7b15.svg";